import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useFavorites } from "../contexts/FavoritesContext";

/**
 * Heart shortcut in the top-right of the Header — jumps straight to /favorites.
 * Visually matches NotificationBell (36px pill, gold hover). Shows a small badge
 * with the total number of saved items (capped at "9+"). Hidden for guests.
 */
export default function FavoritesNavIcon() {
  const { user } = useAuth();
  const { favSet } = useFavorites();
  if (!user) return null;
  const count = favSet.size;
  return (
    <Link
      to="/favorites"
      aria-label={`Favorites${count ? ` (${count} saved)` : ""}`}
      data-testid="nav-favorites-icon"
      className="relative w-9 h-9 flex items-center justify-center rounded-full border border-white/15 hover:border-gold hover:text-gold transition-colors"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
      {count > 0 && (
        <span
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-gold text-black text-[10px] leading-[18px] font-medium text-center"
          data-testid="nav-favorites-count"
        >
          {count > 9 ? "9+" : count}
        </span>
      )}
    </Link>
  );
}
